import UserManagementRoute from './user-management-route';

export default UserManagementRoute;
